import React from "react";
import "./components.css";
import { Col, Container, Row } from "react-bootstrap";
import { Cube, Code, Develop, Dart } from "./svg";
import Image from "next/image";
import sideImg from "../../public/assets/images/side-img.png";
import Link from "next/link";

const SERVICES_DATA = [
  {
    category: "Frontend",
    title: "Frontend Development",
    description:
      "React, Next.js, Angular, Vue — fast, modern, SEO-optimized UIs built for performance and user experience.",
    bgColor: "#fff",

    icon: "🌐",
  },
  {
    category: "Backend",
    title: "Backend Development",
    description:
      "Node.js, .NET, Django — we craft reliable APIs and scalable server-side solutions for complex business logic.",
    bgColor: "#fff",

    icon: "⚙️",
  },
  {
    category: "Mobile App",
    title: "Mobile App Development",
    description:
      "Build high-performance Android/iOS apps using Flutter & React Native with native feel and blazing speed.",
    bgColor: "#fff",

    icon: "📱",
  },
  // {
  //   category: "UI/UX Design",
  //   title: "UI/UX Design",
  //   description:
  //     "Intuitive interfaces and beautiful experiences designed in Figma and Adobe XD — from wireframes to prototypes.",
  //   bgColor: "#FAF8E6",
  //   icon: "🎨",
  // },
  {
    category: "Cloud & DevOps",
    title: "Cloud & DevOps",
    description:
      "AWS, Azure, GCP — deploy scalable systems with CI/CD, Docker, Kubernetes, and 99.99% uptime infrastructure.",
    bgColor: "#fff",
    icon: "☁️",
  },
  {
    category: "AI & ML",
    title: "AI & ML Integration",
    description:
      "Unlock automation and personalization with AI/ML models integrated into your product using Python, TensorFlow & more.",
    bgColor: "#fff",
    icon: "🧠",
  },
];

const ServiceCard = ({ category, title, description, bgColor, icon }) => (
  <div className="services-box mb-4">
    <div className="services-inner">
      <div className="d-flex gap-2 mb-3 align-items-center">
        <div className="icon" style={{ background: bgColor }}>
          {icon}
        </div>
        <p>{category}</p>
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
        {/* <div className="service-box-footer">Read More</div> */}
  </div>
);

const Services = () => {
  return (
    <div className="services-main-section">
      <Container>
        <Row className="py-lg-5">
          <Col xl={8} lg={8}>
            <Row>
              <Col xl={8} lg={12}>
                <h4 className="com-title reveal fade-bottom">
                  Our Awesome <span>services</span> give you success.
                </h4>
                <p
                  style={{ opacity: 0.5 }}
                  className="pe-md-5 reveal fade-bottom"
                >
                  Have an idea? Work with us and see how it goes. We promise to
                  go the extra mile for every project that we take on board.
                </p>
              </Col>

              <Col xl={6} md={6} sm={12} className="mt-5 reveal fade-bottom">
                {SERVICES_DATA.slice(0, 3).map((service, index) => (
                  <ServiceCard {...service} key={index} />
                ))}
              </Col>
              <Col xl={6} md={6} sm={12} className="reveal fade-bottom">
                {SERVICES_DATA.slice(2, 6).map((service, index) => (
                  <ServiceCard {...service} key={index} />
                ))}
              </Col>
            </Row>
          </Col>
          <Col
            xl={4}
            lg={4}
            style={{ position: "relative" }}
            className="d-none d-lg-block"
          >
            <Image
              src={sideImg}
              alt="Our Awesome services give you success"
              className="side-img"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Services;
